(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lamp-localization"] && !Shopify.designMode) return;
  try {
    (()=>{const root=document.getElementById('lamp-localization'),form=document.getElementById('LampLocalizationForm');if(!root||!form)return;
const key='xavorezella_locale_choice',remember=()=>{document.cookie=key+'=1; Path=/; Max-Age=15552000; SameSite=Lax; Secure'};
const returnTo=form.querySelector('[name="return_to"]');if(returnTo)returnTo.value=location.pathname+location.search;
form.addEventListener('submit',()=>{if(returnTo)returnTo.value=location.pathname+location.search;remember()});
document.addEventListener('click',e=>{if(!root.contains(e.target))root.open=false});root.addEventListener('keydown',e=>{if(e.key==='Escape'){root.open=false;root.querySelector('summary').focus()}});
const chosen=document.cookie.split(';').some(c=>c.trim().startsWith(key+'='));
if(!chosen){remember();if(root.dataset.currentCurrency!=='USD'&&form.querySelector('option[value="US"]')){form.elements.country_code.value='US';document.documentElement.classList.add('lamp-localization-loading');form.submit();setTimeout(()=>document.documentElement.classList.remove('lamp-localization-loading'),7000)}}
})();
  } catch(e) { console.error(e); }
})();

})();
